// extracted by mini-css-extract-plugin
export var subtitle = "_d5-2";
export var title = "_d5-0";
export var titleNoWrap = "_d5-1";